export const keys = {
  token: 'react_native_lms_token',
};
